<style scoped>
    .humtog_manu_i {
        z-index: 5;
        position: absolute;
        top: -15px;
        right: 0;
    }

    .el-icon-arrow-down_stop {
        position: absolute;
        top: 12px;
        right: 0;
    }

    .manu_and_post {
        position: relative;
    }

    .lexjwa {
        position: relative;
        display: block;
        width: 100%;
        padding-top: 17px;
        padding-bottom: 17px;
        border-bottom: 1px solid #d6d6d6 !important;
        background: white;
        padding-left: 15px;
        padding-right: 15px;
    }

    .headerbox {
        max-width: 1200px;
        margin: auto !important;
    }

    .side-menu-wrapper .box img {

        width: 33px !important;
        height: 33px !important;
        border-radius: 50%;

    }

    .pst_b {
        float: right;
        margin-right: 60px;
        border-radius: 7px !important;
        padding: 7px 15px 9px 15px !important;
    }

    .logo {
        width: 125px !important;
    }

    .humtog_notifications {
        display: inline-block;
        float: right;
    }

    .humtog_notifications a {
        margin-left: 10px;
        margin-right: 10px;
        cursor: pointer;
        color: #606266;
    }

    .submit_pst {
        padding-right: 32px;
    }

    .headericons {
        font-size: 20px;
    }

    .submitapost {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #3057ff;
        border: 1px solid #DCDFE6;
        border-color: #234cff;
        color: #ececec;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 16px;
        padding: 6px 12px 9px 16px;
        outline: none;
        margin: 0;
        margin-top: -4px;
        -webkit-transition: .1s;
        transition: .1s;
    }

    .submitapost:hover {

        background: #4869fd;
        border: 1px solid #DCDFE6;
        border-color: #5a78fd;

    }

    .noti {

    .item {
        position: relative;
    }

    }


    @media (max-width: 600px) {
        .bsd {
            display: none;
        }

        .lexjwa {
            padding-bottom: 3px;
        }
    }
</style>
<template>
    <div class="lexjwa">
        <el-row v-if="isLoggedIn" class="headerbox">
            <div style="margin-left: 0px; padding-left: 0px !important; display: inline-block; float: left;">
                <el-tooltip content="Go to Homepage" placement="bottom" transition="false" :open-delay="700">
                    <img src="/imgs/humtog.png" @click="home" class="logo" alt="humtog">
                </el-tooltip>
                <el-tooltip content="Go to Homepage" placement="bottom" transition="false" :open-delay="700">
                    <img src="/imgs/humtog-mob.png" @click="home" class="logo-mob" alt="humtog">
                </el-tooltip>
            </div>
                <el-tooltip content="Dark Mode" placement="bottom" transition="false" :open-delay="700">            
               <el-switch v-model="$root.$data.darkMode" style="left: 18px; top: 3px;"></el-switch>
                 </el-tooltip>

            <div style="margin-left: 20px; padding-left: 0 !important; display: inline-block; float: left;">
             <!--   <el-dropdown trigger="click">
                    <span class="el-dropdown-link">{{ selectedLocation }}<i class="el-icon-arrow-down el-icon--right"></i></span>
                    <el-dropdown-menu slot="dropdown">
                        <template v-for="item in locations">
                            <el-dropdown-item @click.native="handleSelect(item)">
                                {{ item.value }}
                            </el-dropdown-item>
                        </template>
                    </el-dropdown-menu>
                </el-dropdown>-->
            </div>

            <div style="padding-right: 0px !important; display: inline-block; float: right;">
                <div class="manu_and_post">
                    <div class="submit_pst">
                        <el-row class="block-col-2" v-if="isLoggedIn">
                            <div class="humtog_notifications">
                                <!-- Messages Inbox -->

                                <el-tooltip content="Messages"
                                            placement="bottom"
                                            transition="false"
                                            :open-delay="500"
                                            class="msg"
                                            v-if="isLoggedIn">
                                    <a class="item"
                                       id="messages-btn"
                                       :class="{'active' : activeRoute === 'messages'}"
                                       @click="Store.modals.messages.show = true"
                                    >
                                        <i class="headericons v-inbox"
                                           aria-hidden="true"></i>
                                        <el-badge v-if="unreadMessages > 0" :value="unreadMessages"
                                                  :max="99">
                                        </el-badge>
                                    </a>
                                </el-tooltip>

                                <!-- Notifications -->
                                <el-tooltip content="Notifications"
                                            placement="bottom"
                                            transition="false"
                                            :open-delay="500"
                                            class="noti"
                                            v-if="isLoggedIn">

                                    <a class="item"
                                       :class="{'active' : activeRoute === 'notifications'}"
                                       @click="viewedNotifcations">
                                        <i class="headericons el-icon-bell"
                                           aria-hidden="true"></i>
                                        <el-badge
                                                v-if="unViewedNotifications > 0"
                                                :value="unViewedNotifications"
                                                :max="99"
                                        ></el-badge>
                                    </a>
                                </el-tooltip>
                                <el-dialog
                                        id="notifications"
                                        title="Notifications"
                                        :visible.sync="Store.modals.notifications.show"
                                        width="85%"
                                >
                                    <notifications></notifications>
                                </el-dialog>
                            </div>
                        </el-row>

                        <!--<el-button class="pst_b" round type="primary" size="mini" @click="submit" v-if="isLoggedIn">-->
                        <!--Submit a Post-->
                        <!--</el-button>-->
                    </div>

                    <div class="side-menu-wrapper humtog_manu_i"
                         :class="{'shade-item relative': showTour && activeTour.id === 'right-sidebar-menu'}">
                        <tour v-if="showTour && activeTour.id == 'right-sidebar-menu'"
                              :position="{ top: '7em', right: '21em' }"></tour>

                        <div class="box"
                             @click="showMenu =! showMenu">
                            <span>
                                <img :src="auth.avatar"
                                     :alt="auth.username"
                                     class="avatar"
                                     :class="showMenu ? 'el-icon-arrow-down_stop' : 'el-icon-arrow-down_stop'">
                                <!--<strong class="break-words">{{ '@' + auth.username }}</strong>-->
                            </span>

                            <!--<i :class="showMenu ? 'el-icon-close' : 'el-icon-arrow-down'"></i>-->
                        </div>

                        <el-collapse-transition>
                            <ul v-show="showMenu"
                                class="menu">
                                <li>
                                    <router-link class="item"
                                                 to="/">Home
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="item"
                                                 :to="'/@' + auth.username">Profile
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="item"
                                                 to="/bookmarks">Bookmarks
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="item"
                                                 :to="{name: 'subscriptions'}">Subscriptions
                                    </router-link>
                                </li>
                                <li class="item"
                                    @click="Store.modals.preferences.show = true">Settings
                                </li>

                                <hr>

                              <!--  <li>
                                    <router-link :to="{name: 'discover-channels'}"
                                                 class="item">Discover categories
                                    </router-link>
                                </li> -->
                                <li class="item"
                                    v-if="meta.isHumtogAdministrator"
                                    @click="Store.modals.newChannel.show = true">Create a new channel
                                </li>
                                <!-- <li class="item"
                                    @click="Store.modals.keyboardShortcutsGuide.show = true">Keyboard shortcuts</li>
                                <li>
                                    <a href="https://help.Humtog.com/"
                                       target="_blank"
                                       class="item">Help center</a>
                                </li> -->

                                <el-collapse-transition>
                                    <div v-show="showSubMenu">
                                        <li>
                                            <router-link to="/about"
                                                         class="item">About
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/rules"
                                                         class="item">Rules
                                            </router-link>
                                        </li>
                                        <!--   <li>
                                            <a href="mailto:info@Humtog.co"
                                               class="item">Contact Us</a>
                                        </li> -->
                                        <li>
                                            <router-link to="/tos"
                                                         class="item">Terms of service
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/privacy-policy"
                                                         class="item">Privacy policy
                                            </router-link>
                                        </li>
                                        <!--  <li>
                                             <a href="https://medium.com/Humtog"
                                                class="item"
                                                target="_blank">Blog</a>
                                         </li>
                                         <li>
                                             <router-link to="/credits"
                                                          class="item">Credits</router-link>
                                         </li>
                                         <li>
                                             <a href="https://github.com/Humtog-co/Humtog"
                                                class="item"
                                                target="_blank">Source code</a>
                                         </li> -->
                                    </div>
                                </el-collapse-transition>

                                <div class="align-center">
                                    <el-button type="text"
                                               @click="showSubMenu =! showSubMenu"
                                               class="go-gray full-width"
                                               size="mini">
                                        {{ showSubMenu ? 'Show less' : 'Show more' }}
                                    </el-button>
                                </div>

                                <hr>

                                <!-- <li class="item go-green"
                                         @click="Store.modals.feedback.show = true">Give feedback</li> -->
                                <li class="item go-red"
                                    @click="signOut">Sign Out
                                </li>
                            </ul>
                        </el-collapse-transition>
                    </div>
                </div>
            </div>

            <div class="humtog_notifications bsd" style="padding-right:20px;">
                <!-- Search -->
                <el-tooltip content="Search"
                            placement="bottom"
                            transition="false"
                            :open-delay="500">
                    <a class="item"
                       @click="Store.modals.search.show = true"
                       :class="{'active' : activeRoute === 'search'}">
                        <i class="headericons el-icon-search"
                           aria-hidden="true"></i>
                    </a>
                </el-tooltip>
                <!-- BookMark -->
                <el-tooltip content="Bookmarks"
                            placement="bottom"
                            transition="false"
                            :open-delay="500"
                            v-if="isLoggedIn">
                    <a @click.prevent="pushRouter('/bookmarks')"
                       href="/bookmarks"
                       class="item"
                       :class="{'active' : activeRoute === 'bookmarks'}">
                        <i class="headericons v-bookmark"
                           aria-hidden="true"></i>
                    </a>
                </el-tooltip>
                <!-- Dashboard -->
                <el-tooltip content="Admin Dashboard"
                            placement="bottom"
                            transition="false"
                            :open-delay="500"
                            v-if="meta.isHumtogSuperadmin">
                    <a class="item"
                       @click.prevent="pushRouter('/big-daddy')"
                       href="/big-daddy">
                        <i class="headericons el-icon-view"
                           aria-hidden="true"></i>
                    </a>
                </el-tooltip>

                <el-tooltip content="Moderator Dashboard"
                            placement="bottom"
                            transition="false"
                            :open-delay="500"
                            v-if="isModerating">
                    <a class="item"
                       @click.prevent="pushRouter('/moderator')"
                       href="/moderator">
                        <i class="headericons el-icon-notebook-1"
                           aria-hidden="true"></i>
                    </a>
                </el-tooltip>

                <!--<el-tooltip content="Login"
                            placement="right"
                            transition="false"
                            :open-delay="500"
                            class="noti"
                            v-if="!isLoggedIn">
                    <a class="item"
                       :class="{'active' : activeRoute === 'notifications'}"
                       @click="loginUser">
                        Login
                        &lt;!&ndash; <i class="el-icon-bell"
                            aria-hidden="true"></i>&ndash;&gt;
                        <el-badge v-if="unreadNotifications > 0" :value="unreadNotifications"
                                  :max="99">
                        </el-badge>
                    </a>
                </el-tooltip>-->
            </div>
        </el-row>
        <el-row :gutter="24" v-else class="headerbox">
            <el-col :span="6">
                <el-tooltip content="Go to Homepage" placement="bottom" transition="false" :open-delay="700">
                    <img src="/imgs/humtog.png" @click="home" class="logo" alt="humtog">
                </el-tooltip>
                <el-tooltip content="Go to Homepage" placement="bottom" transition="false" :open-delay="700">
                    <img src="/imgs/humtog-mob.png" @click="home" class="logo-mob" alt="humtog">
                </el-tooltip>
            </el-col>

            <div class="humtog_notifications">
                <!-- Search -->
                <el-tooltip content="Search"
                            placement="bottom"
                            transition="false"
                            :open-delay="500">
                    <a class="item"
                       @click="Store.modals.search.show = true"
                       :class="{'active' : activeRoute === 'search'}">
                        <i class="el-icon-search"
                           aria-hidden="true"></i>
                    </a>
                </el-tooltip>

                <el-button round
                           @click="loginIn"
                           v-if="!isLoggedIn"
                           size="mini"
                           class="pur_p"
                           type="primary">
                    Login
                </el-button>
                <el-button round
                           @click="signup"
                           v-if="!isLoggedIn"
                           size="mini"
                           class="pur_p">
                    Sign Up
                </el-button>
            </div>
        </el-row>
    </div>
</template>
<script>
    import Helpers from '../mixins/Helpers';
    import Tour from '../components/Tour';
    import Notifications from "./Notifications";

    export default {
        mixins: [Helpers],

        components: {Notifications, Tour},

        data() {
            return {
                subscribedFilter: '',
                showMenu: false,
                showSubMenu: false,
                unViewedNotifications: 0,
                centerDialogVisible: false,
                locations: [
                    {value: 'Global', link: '/l/global'},
                    {value: 'India', link: '/l/india'},
                    {value: 'United States', link: '/l/united-states'},
                    {value: 'United Kingdom', link: '/l/united-kingdom'},
                ],
                selectedLocation: 'Select location'
            };
        },

        watch: {
            $route: function () {
                this.subscribedFilter = '';

                this.getCurrentLocationName();
            },

            locations: function() {
                this.getCurrentLocationName();
            },

            showMenu() {
                if (this.showMenu === false) {
                    this.showSubMenu = false;
                }
            }
        },

        computed: {
            showLoadMoreChannels() {
                return this.channels.length > this.channelsLimit && !this.subscribedFilter;
            },

            showDiscoverChannels() {
                return (
                    this.channels.length < this.channelsLimit &&
                    !this.subscribedFilter &&
                    Store.settings.rightSidebar.channelsFilter == 'subscribed'
                );
            },

            channels() {
                if (this.filter == 'bookmarked') {
                    return Store.state.bookmarkedChannels;
                }

                if (this.filter == 'moderating') {
                    return Store.state.moderatingChannels;
                }

                // subscribed
                return Store.state.subscribedChannels;
            },

            channelsCount() {
                return this.channels.length;
            },

            showChannelAvatars() {
                return Store.settings.rightSidebar.showChannelAvatars;
            },

            channelsLimit() {
                return Store.settings.rightSidebar.channelsLimit;
            },

            theme() {
                if (!this.showTour) {
                    return 'theme-' + this.str_slug(Store.settings.rightSidebar.color) + ' overflow-hidden';
                }

                return 'theme-' + this.str_slug(Store.settings.rightSidebar.color);
            },

            filter() {
                return Store.settings.rightSidebar.channelsFilter;
            },

            filterForHumans() {
                if (this.filter == 'subscribed') return 'Subscribed Channels';

                if (this.filter == 'bookmarked') return 'Bookmarked Channels';

                if (this.filter == 'moderating') return 'Moderating Channels';
            },

            sortedSubscribeds() {
                let self = this;

                return _.orderBy(
                    self.channels.filter(
                        channel => channel.name.toLowerCase().indexOf(self.subscribedFilter.toLowerCase()) !== -1
                    ),
                    'subscribers_count',
                    'desc'
                ).slice(0, self.channelsLimit > 2 ? self.channelsLimit : 2);
            },
            unreadMessages() {
                return Store.state.contacts.filter(
                    (item) =>
                        item.last_message.author.id != auth.id &&
                        item.last_message.read_at == null
                ).length;
            },
            unreadNotifications() {
                return Store.state.notifications.filter(
                    (item) => item.read_at == null
                ).length;
            },

            activeRoute() {
                if (this.$route.name === 'home') {
                    return 'home';
                }

                if (
                    this.$route.name === 'bookmarked-submissions' ||
                    this.$route.name === 'bookmarked-comments' ||
                    this.$route.name === 'bookmarked-users' ||
                    this.$route.name === 'bookmarked-channels'
                ) {
                    return 'bookmarks';
                }

                if (this.$route.params.username == auth.username) {
                    return 'profile';
                }

                if (this.$route.name === 'submit') {
                    return 'submit';
                }
            },
        },

        created() {
            this.$eventHub.$on('pressed-esc', this.closeMenu);
            this.getNotifications()
            this.getCurrentLocationName();

            /*axios.get("/location")
                .then(response => this.location(response))
                .catch(error => this.errorLocation(error));*/
        },

        methods: {
            getCurrentLocationName() {
                let hasLocation = false;
                this.locations.forEach(location => {
                    if (location.link === this.$route.path) {
                        this.selectedLocation = location.value;
                        hasLocation = true
                    }
                });

                if (!hasLocation) {
                    this.selectedLocation = 'Select location';
                }
            },

            location(response) {
                if (response.status == 200) {

                    var result = response.data.data.map(item => ({
                        value: item.name,
                        link: '/l/' + item.slug
                    }));

                    this.locations = result;
                }
            },

            handleSelect(item) {
                this.$router.push({path: item.link})
            },

            qwe() {
                console.log(123123)
            },
            viewedNotifcations() {
                Store.modals.notifications.show = !Store.modals.notifications.show
                axios.patch('/notification-viewed')
                    .then(response => {
                        this.unViewedNotifications = 0
                    });
            },

            getNotifications() {
                if (!!auth.id) {
                    axios.get('/notifications', {
                        params: {
                            filter: 'unseen'
                        }
                    }).then((response) => {
                        if (response.data.data.length > 0) {
                            Store.state.notifications = response.data.data;

                            this.unViewedNotifications = response.data.data.filter(item => !item.viewed).length
                        }
                    });
                }

            },

            loginIn() {
                this.mustBeLogin();
            },

            home() {
                this.$router.push('/');
            },

            gotoskndr() {
                this.$router.push('/signup');
            },
            loginUser() {
                this.$router.push('/signin');
            },
            signup() {
                this.$router.push('/signup');
            },

            submit() {
                this.$eventHub.$emit('submit');
            },
            closeMenu() {
                this.showMenu = false;
            },

            moreChannels() {
                Store.settings.rightSidebar.channelsLimit += 15;
            },

            pushToDiscoverChannels() {
                this.$router.push({name: 'discover-channels'});
            },

            lessChannels() {
                Store.settings.rightSidebar.channelsLimit -= 15;
            },

            signOut() {
                this.$confirm(`Are you sure about signing out of your account?`, 'Confirm', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Never mind',
                    type: 'warning'
                })
                    .then(() => {
                        Vue.clearLS();

                        axios
                            .post('/logout')
                            .then(() => {
                                window.location = '/';
                            })
                            .catch(() => {
                                this.$message({
                                    message: 'Something went wrong.',
                                    type: 'error'
                                });
                            });
                    })
                    .catch(() => {
                    });
            },
            pushRouter(route) {
                this.$eventHub.$emit('close');

                this.$router.push(route);
            },

            goHome() {
                if (this.$route.name != 'home') {
                    Store.page.home.clear();
                }

                this.pushRouter('/');
            },

            close(e) {
                if (!this.$el.contains(e.target)) {
                    this.showMenu = false
                }
            }
        },

        mounted() {
            document.addEventListener('click', this.close)
        },
        beforeDestroy() {
            document.removeEventListener('click', this.close)
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/GlobalHeader.vue